export const downloadPdf = (object: any, nameOfPdf: string) => {
	const file = new Blob([object], {
		type: 'image/pdf',
	});

	if (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0) {
		// IE
		(window.navigator as any).msSaveBlob(file, `${nameOfPdf}.pdf`);
	} else {
		const a = document.createElement('a');
		a.style.display = 'none';
		document.body.appendChild(a);
		const pdfUrl = window.URL.createObjectURL(file);
		a.href = pdfUrl;
		a.download = `${nameOfPdf}.pdf`;
		a.click();
	}
};
